// Owner: ui-layers (plan §12 initial-JS budget); the client itself is collab-kit's lib/realtime.ts.
//
// The authenticated layouts keep the realtime channel open while they are mounted. The client (SSE,
// tab leader election, topic fan-out) loads beside the first paint instead of in it: the layouts only
// import this tiny hook, which loads lib/realtime.ts when the layout mounts.
import { useEffect } from 'react';

const loadRealtime = () => import('./realtime');

export function useRealtimeChannel(): void {
  useEffect(() => {
    let release: (() => void) | undefined;
    let disposed = false;
    void loadRealtime().then((m) => {
      if (!disposed) release = m.retainRealtime();
    });
    return () => {
      disposed = true;
      release?.();
    };
  }, []);
}
